<template>
<div class="neto">
  <md-progress-bar md-mode="indeterminate" v-if="loading"/>
  <div id="netochart"></div>
</div>
</template>

<script>
export default {
  mounted(){
    google.charts.load('current', {'packages':['corechart']})
    google.charts.setOnLoadCallback(this.drawChart)
  },
  data() {
    return {
      loading: true
    }
  },
  methods: {
    drawChart(){
      var data = google.visualization.arrayToDataTable([
        ['Mes','Neto'],
        ['Ene',18500],
        ['Feb',14700],
        ['Mar',4900],
        ['Abr',9000],
        ['May',17500],
        ['Jun',7600],
        ['Jul',15100]
      ])
      var options = {
        title: 'Ingresos Netos de Planilla',
        legend: window.innerWidth < 1200 ? 'top' : 'right',
        hAxis: {title: 'Mes', titleTextStyle: {color: 'red'}},
        colors: ['#d8ff00']
      }
      var chart = new google.visualization.ColumnChart(document.getElementById('netochart'))

      chart.draw(data, options)
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: '../assets/img/';

//2-VENDORS

//3-TOOLS
//functions
//background-image function
@function bimg($img){
  @return url($p-img+$img);
}
//mixins
@mixin mqwh($min-width,$max-height){
  @media (min-width: $min-width) and (max-height: $max-height){
    @content;
  }
}

@mixin mq($min-width){
  @media screen and (min-width: $min-width){
    @content;
  }
}

//8-TRUMPS
#netochart{
  width: 360px;
  height: 225px;
  @include mq('700px'){
    height: 19rem;
    width: 26rem;
  }
  @include mq($lg){
    width: 525px;
  }
}
.neto{
  padding: 2rem 0;
  background-color: #fff;
  display: inline-block;
  border-radius: .6rem;
}
</style>
